export enum TableType {
  USERS = 'USERS',
  REPORTS = 'REPORTS',
  REPORT_HISTORY = 'REPORT_HISTORY',
  REPORT_RESULT = 'REPORT_RESULT',
  GROUPS = 'GROUPS',
  SUB_STATS = 'SUB_STATS',
  INDIVIDUAL_USERS = 'INDIVIDUAL_USERS'
}
